module.exports = __webpack_public_path__ + "static/media/Roswell_5.fe09ca40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Roswell_5.jpg
// module id = 497
// module chunks = 0